import * as React from 'react';
import Svg, { SvgProps, Path } from 'react-native-svg';

const TablesIcon40 = (props: SvgProps) => <Svg
  width='41'
  height='40'
  viewBox='0 0 41 40'
  fill='none'
  {...props}
>
  <Path
    d='M36 10.6522V9C36 8.44772 35.5523 8 35 8H20M4 10.6522V9C4 8.44771 4.44772 8 5 8H20M20 14.2609H15.7571C15.3093 14.2609 14.9161 14.5586 14.7946 14.9896L10 32M20 14.2609H24.2429C24.6907 14.2609 25.0839 14.5586 25.2054 14.9896L30 32M20 14.2609V8'
    stroke='#0058AD'
    strokeWidth='2'
    strokeLinecap='round'
    strokeLinejoin='round'
  />
</Svg>;

export default TablesIcon40;
